import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  ArrowRight, 
  ArrowLeft, 
  Users, 
  Calendar, 
  Utensils, 
  Coffee, 
  Cake, 
  Truck,
  CheckCircle,
  Sparkles,
  Calculator,
  Send,
  RotateCcw,
  Salad,
  Beef,
  Fish,
  Leaf,
  Soup,
  Cookie,
  Wine,
  HandPlatter,
  ChevronDown
} from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Checkbox } from '../components/ui/checkbox';

const BuffetkoneePage = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [selections, setSelections] = useState({
    eventType: null,
    guestCount: '',
    starters: [],
    salads: [],
    mainCourses: {
      possu: { selected: false, dish: '' },
      harka: { selected: false, dish: '' },
      kana: { selected: false, dish: '' },
      kala: { selected: false, dish: '' },
      kasvis: { selected: false, dish: '' },
      keitot: { selected: false, dish: '' }
    },
    sides: [],
    breads: [],
    wantsDessert: null,
    desserts: [],
    drinks: [],
    services: {
      tarjoilu: { selected: false, hours: 4 },
      kattaus: false,
      astiat: false
    },
    delivery: null,
    contact: {
      name: '',
      email: '',
      phone: '',
      date: '',
      message: ''
    }
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  // Price data (hidden from customer)
  const prices = {
    starters: 3,
    salads: 4.5,
    mainCourses: {
      possu: 12.50,
      harka: 16.50,
      kana: 12.50,
      kala: 16.50,
      kasvis: 10.50,
      keitot: 11.50
    },
    sides: 1.50,
    breads: 1.50,
    desserts: {
      mokkapala: 2,
      porkkanakakku: 2,
      juustokakku: 4.50,
      taytekakku: 4.50
    },
    drinks: {
      mehu: 1,
      kotikalja: 1,
      kahvi: 2.50,
      tee: 2.50
    },
    services: {
      tarjoiluPerHour: 50,
      kattausPerPerson: 1,
      astiatPerPerson: 3
    },
    delivery: 50
  };

  // Options data
  const starterOptions = [
    { value: 'savukalaleike', label: 'Savukalaleike' },
    { value: 'meetvurstilautanen', label: 'Meetvurstilautanen' },
    { value: 'juustolautanen', label: 'Juustolautanen' },
    { value: 'carpaccio', label: 'Carpaccio' }
  ];

  const saladOptions = [
    { value: 'vihersalaatti', label: 'Vihersalaatti' },
    { value: 'caesarsalaatti', label: 'Caesar-salaatti' },
    { value: 'perunasalaatti', label: 'Perunasalaatti' },
    { value: 'pastasalaatti', label: 'Pastasalaatti' },
    { value: 'coleslaw', label: 'Coleslaw' },
    { value: 'punajuurisalaatti', label: 'Punajuurisalaatti' }
  ];

  const mainCourseOptions = {
    possu: [
      { value: 'porsaanpaisti', label: 'Porsaanpaisti' },
      { value: 'porsaanfilee', label: 'Porsaanfilee' },
      { value: 'possun-ulkofilee', label: 'Possun ulkofilee' }
    ],
    harka: [
      { value: 'harkaa-burgundilaisittain', label: 'Härkää burgundilaisittain' },
      { value: 'paahtopaisti', label: 'Paahtopaisti' },
      { value: 'stroganoff', label: 'Stroganoff' }
    ],
    kana: [
      { value: 'kanan-koipireisi', label: 'Kanan koipireisi' },
      { value: 'kanaa-currykastikkeessa', label: 'Kanaa currykastikkeessa' },
      { value: 'taytettya-kananrintaa', label: 'Täytettyä kananrintaa' }
    ],
    kala: [
      { value: 'lohta-sitruunakastikkeella', label: 'Lohta sitruunakastikkeella' },
      { value: 'graavilohi', label: 'Graavilohi' },
      { value: 'siikaa-voikastikkeella', label: 'Siikaa voikastikkeella' }
    ],
    kasvis: [
      { value: 'kasvislasagne', label: 'Kasvislasagne' },
      { value: 'kasvismoussaka', label: 'Kasvismoussaka' },
      { value: 'taytettya-paprikaa', label: 'Täytettyä paprikaa' }
    ],
    keitot: [
      { value: 'lohikeitto', label: 'Lohikeitto' },
      { value: 'kermainen-kasvissosekeitto', label: 'Kermainen kasvissosekeitto' },
      { value: 'harkaa-ja-juureksia', label: 'Härkää ja juureksia -keitto' }
    ]
  };

  const sideOptions = [
    { value: 'keitetyt-perunat', label: 'Keitetyt perunat' },
    { value: 'lohkoperunat', label: 'Lohkoperunat' },
    { value: 'valkosipuliperunat', label: 'Valkosipuliperunat' },
    { value: 'perunamuusi', label: 'Perunamuusi' },
    { value: 'riisi', label: 'Riisi' },
    { value: 'kauden-kasvikset', label: 'Kauden kasvikset' }
  ];

  const breadOptions = [
    { value: 'saaristolaisleipa', label: 'Saaristolaisleipä' },
    { value: 'focaccia', label: 'Focaccia' },
    { value: 'patongit', label: 'Patongit' }
  ];

  const dessertOptions = [
    { value: 'mokkapala', label: 'Mokkapala' },
    { value: 'porkkanakakku', label: 'Porkkanakakku' },
    { value: 'juustokakku', label: 'Juustokakku' },
    { value: 'taytekakku', label: 'Täytekakku' }
  ];

  const drinkOptions = [
    { value: 'mehu', label: 'Mehu' },
    { value: 'kotikalja', label: 'Kotikalja' },
    { value: 'kahvi', label: 'Kahvi' },
    { value: 'tee', label: 'Tee' }
  ];

  // Calculate total price
  const calculatePrice = () => {
    const guests = parseInt(selections.guestCount) || 0;
    let total = 0;

    // Starters
    total += selections.starters.length * prices.starters * guests;

    // Salads
    total += selections.salads.length * prices.salads * guests;

    // Main courses
    Object.keys(selections.mainCourses).forEach(key => {
      if (selections.mainCourses[key].selected && selections.mainCourses[key].dish) {
        total += prices.mainCourses[key] * guests;
      }
    });

    // Sides
    total += selections.sides.length * prices.sides * guests;

    // Breads
    total += selections.breads.length * prices.breads * guests;

    // Desserts
    selections.desserts.forEach(dessert => {
      total += prices.desserts[dessert] * guests;
    });

    // Drinks
    selections.drinks.forEach(drink => {
      total += prices.drinks[drink] * guests;
    });

    // Services
    if (selections.services.tarjoilu.selected) {
      total += prices.services.tarjoiluPerHour * selections.services.tarjoilu.hours;
    }
    if (selections.services.kattaus) {
      total += prices.services.kattausPerPerson * guests;
    }
    if (selections.services.astiat) {
      total += prices.services.astiatPerPerson * guests;
    }

    // Delivery
    if (selections.delivery === 'kuljetus') {
      total += prices.delivery;
    }

    return total;
  };

  const steps = [
    {
      id: 'eventType',
      title: 'Millainen tilaisuus?',
      subtitle: 'Valitse tilaisuuden tyyppi',
      icon: Calendar
    },
    {
      id: 'guestCount',
      title: 'Montako vierasta?',
      subtitle: 'Syötä henkilömäärä',
      icon: Users
    },
    {
      id: 'starters',
      title: 'Alkupalat',
      subtitle: 'Valitse alkupalat',
      icon: Utensils
    },
    {
      id: 'salads',
      title: 'Salaatit',
      subtitle: 'Valitse salaatit',
      icon: Salad
    },
    {
      id: 'mainCourses',
      title: 'Pääruoat',
      subtitle: 'Valitse pääruoat ja ruokalajit',
      icon: Beef
    },
    {
      id: 'sides',
      title: 'Lisukkeet',
      subtitle: 'Valitse lisukkeet',
      icon: Utensils
    },
    {
      id: 'breads',
      title: 'Leivät',
      subtitle: 'Valitse leivät',
      icon: Cookie
    },
    {
      id: 'desserts',
      title: 'Jälkiruoat',
      subtitle: 'Haluatko jälkiruoan?',
      icon: Cake
    },
    {
      id: 'drinks',
      title: 'Juomat',
      subtitle: 'Valitse juomat',
      icon: Coffee
    },
    {
      id: 'services',
      title: 'Lisäpalvelut',
      subtitle: 'Valitse lisäpalvelut',
      icon: HandPlatter
    },
    {
      id: 'delivery',
      title: 'Toimitus',
      subtitle: 'Nouto vai kuljetus?',
      icon: Truck
    },
    {
      id: 'contact',
      title: 'Yhteystiedot',
      subtitle: 'Täytä yhteystietosi',
      icon: Send
    }
  ];

  const handleMultiSelect = (stepId, value) => {
    const current = selections[stepId] || [];
    const updated = current.includes(value)
      ? current.filter(v => v !== value)
      : [...current, value];
    setSelections({ ...selections, [stepId]: updated });
  };

  const handleMainCourseToggle = (category) => {
    setSelections({
      ...selections,
      mainCourses: {
        ...selections.mainCourses,
        [category]: {
          ...selections.mainCourses[category],
          selected: !selections.mainCourses[category].selected,
          dish: !selections.mainCourses[category].selected ? '' : selections.mainCourses[category].dish
        }
      }
    });
  };

  const handleMainCourseDish = (category, dish) => {
    setSelections({
      ...selections,
      mainCourses: {
        ...selections.mainCourses,
        [category]: {
          ...selections.mainCourses[category],
          dish: dish
        }
      }
    });
  };

  const handleContactChange = (field, value) => {
    setSelections({
      ...selections,
      contact: { ...selections.contact, [field]: value }
    });
  };

  const canProceed = () => {
    const step = steps[currentStep];
    switch (step.id) {
      case 'eventType':
        return selections.eventType !== null;
      case 'guestCount':
        return parseInt(selections.guestCount) >= 10;
      case 'starters':
      case 'salads':
      case 'sides':
      case 'breads':
      case 'drinks':
        return true; // Optional steps
      case 'mainCourses':
        return Object.values(selections.mainCourses).some(m => m.selected && m.dish);
      case 'desserts':
        if (selections.wantsDessert === false) return true;
        if (selections.wantsDessert === true) return selections.desserts.length > 0;
        return selections.wantsDessert !== null;
      case 'services':
      case 'delivery':
        return true;
      case 'contact':
        return selections.contact.name && selections.contact.email && selections.contact.phone;
      default:
        return true;
    }
  };

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSubmit = () => {
    console.log('Tarjouspyyntö:', selections, 'Hinta:', calculatePrice());
    setIsSubmitted(true);
  };

  const resetForm = () => {
    setCurrentStep(0);
    setSelections({
      eventType: null,
      guestCount: '',
      starters: [],
      salads: [],
      mainCourses: {
        possu: { selected: false, dish: '' },
        harka: { selected: false, dish: '' },
        kana: { selected: false, dish: '' },
        kala: { selected: false, dish: '' },
        kasvis: { selected: false, dish: '' },
        keitot: { selected: false, dish: '' }
      },
      sides: [],
      breads: [],
      wantsDessert: null,
      desserts: [],
      drinks: [],
      services: {
        tarjoilu: { selected: false, hours: 4 },
        kattaus: false,
        astiat: false
      },
      delivery: null,
      contact: { name: '', email: '', phone: '', date: '', message: '' }
    });
    setIsSubmitted(false);
  };

  const currentStepData = steps[currentStep];
  const progress = ((currentStep + 1) / steps.length) * 100;
  const totalPrice = calculatePrice();

  // Event type options
  const eventTypes = [
    { value: 'birthday', label: 'Syntymäpäivät' },
    { value: 'memorial', label: 'Muistotilaisuus' },
    { value: 'corporate', label: 'Yritystilaisuus' },
    { value: 'wedding', label: 'Häät / Juhlat' },
    { value: 'other', label: 'Muu tilaisuus' }
  ];

  // Main course labels
  const mainCourseLabels = {
    possu: 'Possu',
    harka: 'Härkä',
    kana: 'Kana',
    kala: 'Kala',
    kasvis: 'Kasvis',
    keitot: 'Keitot'
  };

  if (isSubmitted) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-emerald-50 to-white py-20">
        <div className="max-w-2xl mx-auto px-6">
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 text-center border-2 border-green-200">
            <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
              <CheckCircle className="w-10 h-10 text-white" />
            </div>
            <h2 className="text-3xl font-bold text-stone-800 mb-4">Kiitos tarjouspyynnöstä!</h2>
            <p className="text-stone-600 mb-6">
              Olemme vastaanottaneet tilauksesi ja otamme sinuun yhteyttä 1-3 arkipäivän kuluessa vahvistaaksemme tilauksen.
            </p>
            
            <div className="bg-emerald-50 rounded-2xl p-6 mb-8 text-left">
              <h3 className="font-semibold text-stone-800 mb-3">Tilauksen yhteenveto:</h3>
              <div className="space-y-2 text-sm text-stone-600">
                <p><strong>Henkilömäärä:</strong> {selections.guestCount} henkilöä</p>
                <p><strong>Tilaisuus:</strong> {eventTypes.find(e => e.value === selections.eventType)?.label}</p>
              </div>
              <div className="mt-4 pt-4 border-t border-emerald-200">
                <div className="flex justify-between items-center">
                  <span className="font-semibold text-stone-800">Kokonaishinta:</span>
                  <span className="text-2xl font-bold text-emerald-700">{totalPrice.toFixed(2)}€</span>
                </div>
                <p className="text-xs text-stone-500 mt-1">sis. alv 14%</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button onClick={resetForm} variant="outline" className="border-2 border-stone-300 rounded-xl px-6 py-3">
                <RotateCcw className="w-4 h-4 mr-2" />
                Aloita alusta
              </Button>
              <Link to="/">
                <Button className="bg-emerald-500 hover:bg-emerald-700 text-white rounded-xl px-6 py-3">
                  Takaisin etusivulle
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const renderStepContent = () => {
    switch (currentStepData.id) {
      case 'eventType':
        return (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {eventTypes.map((option) => {
              const isSelected = selections.eventType === option.value;
              return (
                <button
                  key={option.value}
                  onClick={() => setSelections({ ...selections, eventType: option.value })}
                  className={`p-4 rounded-xl border-2 text-left transition-all ${
                    isSelected 
                      ? 'border-emerald-500 bg-emerald-50 shadow-md' 
                      : 'border-stone-200 hover:border-emerald-300 hover:bg-emerald-50/50'
                  }`}
                >
                  <span className={`font-medium ${isSelected ? 'text-emerald-800' : 'text-stone-800'}`}>
                    {option.label}
                  </span>
                </button>
              );
            })}
          </div>
        );

      case 'guestCount':
        return (
          <div className="max-w-xs">
            <Label className="text-stone-700 font-medium">Henkilömäärä</Label>
            <Input
              type="number"
              min="10"
              max="500"
              value={selections.guestCount}
              onChange={(e) => setSelections({ ...selections, guestCount: e.target.value })}
              className="mt-2 text-2xl font-bold text-center py-6 border-2 border-emerald-200 rounded-xl focus:border-emerald-400"
              placeholder="0"
            />
            <p className="text-sm text-stone-500 mt-2">Vähintään 10 henkilöä</p>
          </div>
        );

      case 'starters':
        return (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {starterOptions.map((option) => {
              const isSelected = selections.starters.includes(option.value);
              return (
                <button
                  key={option.value}
                  onClick={() => handleMultiSelect('starters', option.value)}
                  className={`p-4 rounded-xl border-2 text-left transition-all ${
                    isSelected 
                      ? 'border-emerald-500 bg-emerald-50 shadow-md' 
                      : 'border-stone-200 hover:border-emerald-300 hover:bg-emerald-50/50'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span className={`font-medium ${isSelected ? 'text-emerald-800' : 'text-stone-800'}`}>
                      {option.label}
                    </span>
                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                      isSelected ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                    }`}>
                      {isSelected && <CheckCircle className="w-4 h-4 text-white" />}
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        );

      case 'salads':
        return (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {saladOptions.map((option) => {
              const isSelected = selections.salads.includes(option.value);
              return (
                <button
                  key={option.value}
                  onClick={() => handleMultiSelect('salads', option.value)}
                  className={`p-4 rounded-xl border-2 text-left transition-all ${
                    isSelected 
                      ? 'border-emerald-500 bg-emerald-50 shadow-md' 
                      : 'border-stone-200 hover:border-emerald-300 hover:bg-emerald-50/50'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span className={`font-medium ${isSelected ? 'text-emerald-800' : 'text-stone-800'}`}>
                      {option.label}
                    </span>
                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                      isSelected ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                    }`}>
                      {isSelected && <CheckCircle className="w-4 h-4 text-white" />}
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        );

      case 'mainCourses':
        return (
          <div className="space-y-4">
            {Object.keys(mainCourseOptions).map((category) => {
              const isSelected = selections.mainCourses[category].selected;
              return (
                <div key={category} className={`rounded-xl border-2 transition-all ${
                  isSelected ? 'border-emerald-500 bg-emerald-50' : 'border-stone-200'
                }`}>
                  <button
                    onClick={() => handleMainCourseToggle(category)}
                    className="w-full p-4 flex items-center justify-between"
                  >
                    <span className={`font-semibold text-lg ${isSelected ? 'text-emerald-800' : 'text-stone-800'}`}>
                      {mainCourseLabels[category]}
                    </span>
                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                      isSelected ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                    }`}>
                      {isSelected && <CheckCircle className="w-4 h-4 text-white" />}
                    </div>
                  </button>
                  
                  {isSelected && (
                    <div className="px-4 pb-4">
                      <select
                        value={selections.mainCourses[category].dish}
                        onChange={(e) => handleMainCourseDish(category, e.target.value)}
                        className="w-full p-3 border-2 border-emerald-200 rounded-lg bg-white focus:border-emerald-400 focus:outline-none"
                      >
                        <option value="">Valitse ruokalaji...</option>
                        {mainCourseOptions[category].map((dish) => (
                          <option key={dish.value} value={dish.value}>{dish.label}</option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        );

      case 'sides':
        return (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {sideOptions.map((option) => {
              const isSelected = selections.sides.includes(option.value);
              return (
                <button
                  key={option.value}
                  onClick={() => handleMultiSelect('sides', option.value)}
                  className={`p-4 rounded-xl border-2 text-left transition-all ${
                    isSelected 
                      ? 'border-emerald-500 bg-emerald-50 shadow-md' 
                      : 'border-stone-200 hover:border-emerald-300 hover:bg-emerald-50/50'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span className={`font-medium ${isSelected ? 'text-emerald-800' : 'text-stone-800'}`}>
                      {option.label}
                    </span>
                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                      isSelected ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                    }`}>
                      {isSelected && <CheckCircle className="w-4 h-4 text-white" />}
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        );

      case 'breads':
        return (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {breadOptions.map((option) => {
              const isSelected = selections.breads.includes(option.value);
              return (
                <button
                  key={option.value}
                  onClick={() => handleMultiSelect('breads', option.value)}
                  className={`p-4 rounded-xl border-2 text-left transition-all ${
                    isSelected 
                      ? 'border-emerald-500 bg-emerald-50 shadow-md' 
                      : 'border-stone-200 hover:border-emerald-300 hover:bg-emerald-50/50'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span className={`font-medium ${isSelected ? 'text-emerald-800' : 'text-stone-800'}`}>
                      {option.label}
                    </span>
                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                      isSelected ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                    }`}>
                      {isSelected && <CheckCircle className="w-4 h-4 text-white" />}
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        );

      case 'desserts':
        return (
          <div className="space-y-6">
            {/* Yes/No choice */}
            <div className="grid grid-cols-2 gap-4">
              <button
                onClick={() => setSelections({ ...selections, wantsDessert: true, desserts: [] })}
                className={`p-4 rounded-xl border-2 transition-all ${
                  selections.wantsDessert === true
                    ? 'border-emerald-500 bg-emerald-50 shadow-md'
                    : 'border-stone-200 hover:border-emerald-300'
                }`}
              >
                <span className={`font-medium ${selections.wantsDessert === true ? 'text-emerald-800' : 'text-stone-800'}`}>
                  Kyllä
                </span>
              </button>
              <button
                onClick={() => setSelections({ ...selections, wantsDessert: false, desserts: [] })}
                className={`p-4 rounded-xl border-2 transition-all ${
                  selections.wantsDessert === false
                    ? 'border-emerald-500 bg-emerald-50 shadow-md'
                    : 'border-stone-200 hover:border-emerald-300'
                }`}
              >
                <span className={`font-medium ${selections.wantsDessert === false ? 'text-emerald-800' : 'text-stone-800'}`}>
                  Ei
                </span>
              </button>
            </div>

            {/* Dessert options if yes */}
            {selections.wantsDessert === true && (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4">
                {dessertOptions.map((option) => {
                  const isSelected = selections.desserts.includes(option.value);
                  return (
                    <button
                      key={option.value}
                      onClick={() => handleMultiSelect('desserts', option.value)}
                      className={`p-4 rounded-xl border-2 text-left transition-all ${
                        isSelected 
                          ? 'border-emerald-500 bg-emerald-50 shadow-md' 
                          : 'border-stone-200 hover:border-emerald-300 hover:bg-emerald-50/50'
                      }`}
                    >
                      <div className="flex items-center justify-between">
                        <span className={`font-medium ${isSelected ? 'text-emerald-800' : 'text-stone-800'}`}>
                          {option.label}
                        </span>
                        <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                          isSelected ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                        }`}>
                          {isSelected && <CheckCircle className="w-4 h-4 text-white" />}
                        </div>
                      </div>
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        );

      case 'drinks':
        return (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {drinkOptions.map((option) => {
              const isSelected = selections.drinks.includes(option.value);
              return (
                <button
                  key={option.value}
                  onClick={() => handleMultiSelect('drinks', option.value)}
                  className={`p-4 rounded-xl border-2 text-left transition-all ${
                    isSelected 
                      ? 'border-emerald-500 bg-emerald-50 shadow-md' 
                      : 'border-stone-200 hover:border-emerald-300 hover:bg-emerald-50/50'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span className={`font-medium ${isSelected ? 'text-emerald-800' : 'text-stone-800'}`}>
                      {option.label}
                    </span>
                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                      isSelected ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                    }`}>
                      {isSelected && <CheckCircle className="w-4 h-4 text-white" />}
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        );

      case 'services':
        const guests = parseInt(selections.guestCount) || 0;
        const recommendedServers = Math.ceil(guests / 25);
        return (
          <div className="space-y-4">
            {/* Tarjoilu */}
            <div className={`rounded-xl border-2 p-4 transition-all ${
              selections.services.tarjoilu.selected ? 'border-emerald-500 bg-emerald-50' : 'border-stone-200'
            }`}>
              <div className="flex items-center justify-between">
                <div>
                  <span className="font-semibold text-stone-800">Tarjoiluhenkilökunta</span>
                  <p className="text-sm text-stone-500">50€/h (min. 4h), suositus: {recommendedServers} tarjoilija(a)</p>
                </div>
                <button
                  onClick={() => setSelections({
                    ...selections,
                    services: {
                      ...selections.services,
                      tarjoilu: {
                        ...selections.services.tarjoilu,
                        selected: !selections.services.tarjoilu.selected
                      }
                    }
                  })}
                  className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                    selections.services.tarjoilu.selected ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                  }`}
                >
                  {selections.services.tarjoilu.selected && <CheckCircle className="w-4 h-4 text-white" />}
                </button>
              </div>
              {selections.services.tarjoilu.selected && (
                <div className="mt-3">
                  <Label className="text-sm text-stone-600">Tuntimäärä</Label>
                  <Input
                    type="number"
                    min="4"
                    value={selections.services.tarjoilu.hours}
                    onChange={(e) => setSelections({
                      ...selections,
                      services: {
                        ...selections.services,
                        tarjoilu: {
                          ...selections.services.tarjoilu,
                          hours: parseInt(e.target.value) || 4
                        }
                      }
                    })}
                    className="mt-1 w-24 border-emerald-200"
                  />
                </div>
              )}
            </div>

            {/* Pöytienkattaus */}
            <button
              onClick={() => setSelections({
                ...selections,
                services: { ...selections.services, kattaus: !selections.services.kattaus }
              })}
              className={`w-full rounded-xl border-2 p-4 text-left transition-all ${
                selections.services.kattaus ? 'border-emerald-500 bg-emerald-50' : 'border-stone-200'
              }`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <span className="font-semibold text-stone-800">Pöytienkattaus</span>
                  <p className="text-sm text-stone-500">Kattaus valmiiksi tilaisuutta varten</p>
                </div>
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                  selections.services.kattaus ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                }`}>
                  {selections.services.kattaus && <CheckCircle className="w-4 h-4 text-white" />}
                </div>
              </div>
            </button>

            {/* Vuokra-astiat */}
            <button
              onClick={() => setSelections({
                ...selections,
                services: { ...selections.services, astiat: !selections.services.astiat }
              })}
              className={`w-full rounded-xl border-2 p-4 text-left transition-all ${
                selections.services.astiat ? 'border-emerald-500 bg-emerald-50' : 'border-stone-200'
              }`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <span className="font-semibold text-stone-800">Vuokra-astiat</span>
                  <p className="text-sm text-stone-500">Lautaset, lasit ja aterimet</p>
                </div>
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                  selections.services.astiat ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                }`}>
                  {selections.services.astiat && <CheckCircle className="w-4 h-4 text-white" />}
                </div>
              </div>
            </button>
          </div>
        );

      case 'delivery':
        return (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <button
              onClick={() => setSelections({ ...selections, delivery: 'nouto' })}
              className={`p-6 rounded-xl border-2 transition-all ${
                selections.delivery === 'nouto'
                  ? 'border-emerald-500 bg-emerald-50 shadow-md'
                  : 'border-stone-200 hover:border-emerald-300'
              }`}
            >
              <span className={`font-semibold text-lg block ${selections.delivery === 'nouto' ? 'text-emerald-800' : 'text-stone-800'}`}>
                Nouto
              </span>
              <span className="text-sm text-stone-500">Noudetaan ravintolasta</span>
            </button>
            <button
              onClick={() => setSelections({ ...selections, delivery: 'kuljetus' })}
              className={`p-6 rounded-xl border-2 transition-all ${
                selections.delivery === 'kuljetus'
                  ? 'border-emerald-500 bg-emerald-50 shadow-md'
                  : 'border-stone-200 hover:border-emerald-300'
              }`}
            >
              <span className={`font-semibold text-lg block ${selections.delivery === 'kuljetus' ? 'text-emerald-800' : 'text-stone-800'}`}>
                Kuljetus
              </span>
              <span className="text-sm text-stone-500">Kotka-Hamina alue (+50€)</span>
            </button>
          </div>
        );

      case 'contact':
        return (
          <div className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <Label className="text-stone-700 font-medium">Nimi *</Label>
                <Input
                  value={selections.contact.name}
                  onChange={(e) => handleContactChange('name', e.target.value)}
                  className="mt-1 border-2 border-stone-200 rounded-xl"
                  placeholder="Nimesi"
                />
              </div>
              <div>
                <Label className="text-stone-700 font-medium">Puhelin *</Label>
                <Input
                  value={selections.contact.phone}
                  onChange={(e) => handleContactChange('phone', e.target.value)}
                  className="mt-1 border-2 border-stone-200 rounded-xl"
                  placeholder="Puhelinnumero"
                />
              </div>
            </div>
            <div>
              <Label className="text-stone-700 font-medium">Sähköposti *</Label>
              <Input
                type="email"
                value={selections.contact.email}
                onChange={(e) => handleContactChange('email', e.target.value)}
                className="mt-1 border-2 border-stone-200 rounded-xl"
                placeholder="sahkoposti@esimerkki.fi"
              />
            </div>
            <div>
              <Label className="text-stone-700 font-medium">Tilaisuuden päivämäärä</Label>
              <Input
                type="date"
                value={selections.contact.date}
                onChange={(e) => handleContactChange('date', e.target.value)}
                className="mt-1 border-2 border-stone-200 rounded-xl"
              />
            </div>
            <div>
              <Label className="text-stone-700 font-medium">Lisätiedot</Label>
              <Textarea
                value={selections.contact.message}
                onChange={(e) => handleContactChange('message', e.target.value)}
                className="mt-1 border-2 border-stone-200 rounded-xl"
                placeholder="Kerro lisätietoja tilaisuudesta..."
                rows={3}
              />
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-50 to-white">
      {/* Hero */}
      <section className="py-12 md:py-16 bg-gradient-to-br from-stone-800 via-stone-900 to-stone-800 relative overflow-hidden">
        <div className="absolute top-10 left-10 w-32 h-32 border-4 border-emerald-500/20 rounded-full" />
        <div className="absolute bottom-10 right-10 w-48 h-48 border-4 border-emerald-500/10 rounded-full" />
        
        <div className="relative max-w-4xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 bg-emerald-500/20 backdrop-blur-sm text-emerald-300 px-4 py-2 rounded-full text-sm font-medium mb-4">
            <Calculator className="w-4 h-4" />
            <span>Pitopalvelun hintalaskuri</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            <span className="font-handwritten text-emerald-400">Buffetkone</span>
          </h1>
          <p className="text-lg text-stone-300 max-w-2xl mx-auto">
            Rakenna oma pitopalvelukokonaisuutesi ja saat tarkan hinnan. 
            Valitse ruokalajit, lisukkeet ja palvelut – me hoidamme loput!
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Main Form Area */}
            <div className="lg:col-span-2">
              <div className="bg-white rounded-3xl shadow-xl p-6 md:p-8 border-2 border-emerald-100">
                {/* Progress bar */}
                <div className="mb-8">
                  <div className="flex justify-between text-sm text-stone-500 mb-2">
                    <span>Vaihe {currentStep + 1}/{steps.length}</span>
                    <span>{Math.round(progress)}% valmis</span>
                  </div>
                  <div className="h-2 bg-stone-100 rounded-full overflow-hidden">
                    <div 
                      className="h-full bg-gradient-to-r from-emerald-500 to-green-500 rounded-full transition-all duration-500"
                      style={{ width: `${progress}%` }}
                    />
                  </div>
                </div>

                {/* Step Content */}
                <div className="min-h-[400px]">
                  <div className="flex items-center gap-3 mb-6">
                    <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-green-500 rounded-xl flex items-center justify-center shadow-lg">
                      <currentStepData.icon className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h2 className="text-2xl font-bold text-stone-800">{currentStepData.title}</h2>
                      <p className="text-stone-500">{currentStepData.subtitle}</p>
                    </div>
                  </div>

                  {renderStepContent()}
                </div>

                {/* Navigation */}
                <div className="flex justify-between mt-8 pt-6 border-t border-stone-100">
                  <Button
                    onClick={prevStep}
                    disabled={currentStep === 0}
                    variant="outline"
                    className="border-2 border-stone-300 rounded-xl px-6 py-3 disabled:opacity-50"
                  >
                    <ArrowLeft className="w-4 h-4 mr-2" />
                    Edellinen
                  </Button>
                  
                  {currentStep === steps.length - 1 ? (
                    <Button
                      onClick={handleSubmit}
                      disabled={!canProceed()}
                      className="bg-gradient-to-r from-emerald-500 to-green-500 hover:from-emerald-700 hover:to-green-600 text-white rounded-xl px-8 py-3 disabled:opacity-50"
                    >
                      Lähetä tarjouspyyntö
                      <Send className="w-4 h-4 ml-2" />
                    </Button>
                  ) : (
                    <Button
                      onClick={nextStep}
                      disabled={!canProceed()}
                      className="bg-stone-900 hover:bg-stone-800 text-white rounded-xl px-6 py-3 disabled:opacity-50"
                    >
                      Seuraava
                      <ArrowRight className="w-4 h-4 ml-2" />
                    </Button>
                  )}
                </div>
              </div>
            </div>

            {/* Price Summary Sidebar */}
            <div className="lg:col-span-1">
              <div className="bg-white rounded-3xl shadow-xl p-6 border-2 border-emerald-100 sticky top-24">
                <h3 className="font-bold text-lg text-stone-800 mb-4 flex items-center gap-2">
                  <Calculator className="w-5 h-5 text-emerald-500" />
                  Yhteenveto
                </h3>
                
                {selections.guestCount && parseInt(selections.guestCount) >= 10 ? (
                  <>
                    <div className="space-y-3 mb-6 text-sm">
                      <div className="flex justify-between">
                        <span className="text-stone-600">Henkilömäärä</span>
                        <span className="font-medium text-stone-800">{selections.guestCount} hlö</span>
                      </div>
                      
                      {selections.starters.length > 0 && (
                        <div className="flex justify-between">
                          <span className="text-stone-600">Alkupalat</span>
                          <span className="text-stone-800">{selections.starters.length} kpl</span>
                        </div>
                      )}
                      
                      {selections.salads.length > 0 && (
                        <div className="flex justify-between">
                          <span className="text-stone-600">Salaatit</span>
                          <span className="text-stone-800">{selections.salads.length} kpl</span>
                        </div>
                      )}
                      
                      {Object.values(selections.mainCourses).some(m => m.selected) && (
                        <div className="flex justify-between">
                          <span className="text-stone-600">Pääruoat</span>
                          <span className="text-stone-800">
                            {Object.values(selections.mainCourses).filter(m => m.selected && m.dish).length} kpl
                          </span>
                        </div>
                      )}
                      
                      {selections.sides.length > 0 && (
                        <div className="flex justify-between">
                          <span className="text-stone-600">Lisukkeet</span>
                          <span className="text-stone-800">{selections.sides.length} kpl</span>
                        </div>
                      )}
                      
                      {selections.breads.length > 0 && (
                        <div className="flex justify-between">
                          <span className="text-stone-600">Leivät</span>
                          <span className="text-stone-800">{selections.breads.length} kpl</span>
                        </div>
                      )}
                      
                      {selections.desserts.length > 0 && (
                        <div className="flex justify-between">
                          <span className="text-stone-600">Jälkiruoat</span>
                          <span className="text-stone-800">{selections.desserts.length} kpl</span>
                        </div>
                      )}
                      
                      {selections.drinks.length > 0 && (
                        <div className="flex justify-between">
                          <span className="text-stone-600">Juomat</span>
                          <span className="text-stone-800">{selections.drinks.length} kpl</span>
                        </div>
                      )}
                    </div>
                    
                    <div className="border-t border-stone-200 pt-4">
                      <div className="flex justify-between items-center">
                        <span className="font-semibold text-stone-800">Yhteensä</span>
                        <div className="text-right">
                          <span className="text-2xl font-bold text-emerald-700">{totalPrice.toFixed(2)}€</span>
                          <p className="text-xs text-stone-500">sis. alv 14%</p>
                        </div>
                      </div>
                    </div>
                    
                    <p className="text-xs text-stone-500 mt-4 bg-emerald-50 p-3 rounded-xl">
                      Hinta päivittyy valintojen mukaan. Lopullinen hinta vahvistetaan tilauksessa.
                    </p>
                  </>
                ) : (
                  <div className="text-center py-8 text-stone-400">
                    <Calculator className="w-10 h-10 mx-auto mb-3 opacity-50" />
                    <p className="text-sm">Syötä henkilömäärä (min. 10) nähdäksesi hinnan</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BuffetkoneePage;
